
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';

interface AIReportingChatInputProps {
  input: string;
  setInput: (val: string) => void;
  isLoading: boolean;
  handleSendMessage: () => void;
}

export const AIReportingChatInput: React.FC<AIReportingChatInputProps> = ({
  input,
  setInput,
  isLoading,
  handleSendMessage,
}) => {
  return (
    <div className="mt-4 flex">
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Ask for a report or provide details..."
        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
        disabled={isLoading}
        className="flex-grow"
      />
      <Button 
        className="ml-2"
        onClick={handleSendMessage}
        disabled={isLoading || !input.trim()}
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
};
